import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { productsData } from '../data';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const InvestmentSummary = () => {
  const theme = useTheme();

  const rows = productsData.map((item) => ({
    tool: item.title,
    detail: item.impacts[0],
    investment: item.investment.replace(' / mes', ''),
  }));

  return (
    <Box sx={{ mb: 6 }}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="primary"
        align="center"
      >
        Resumen
      </Typography>
      <Typography variant="h4" fontWeight={700} align="center" color="primary" gutterBottom>
        Plan de Dominio Multi-Pantalla
      </Typography>
      <TableContainer
        component={Paper}
        elevation={2}
        sx={{ maxWidth: 800, mx: 'auto', borderRadius: 2, mt: 2 }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Herramienta de marca</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Detalle y alcance</TableCell>
              <TableCell align="right" sx={{ color: 'white', fontWeight: 700 }}>
                Inversión
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.tool} hover>
                <TableCell sx={{ fontWeight: 600, verticalAlign: 'top' }}>{row.tool}</TableCell>
                <TableCell sx={{ color: 'text.secondary', verticalAlign: 'top', lineHeight: 1.65 }}>
                  {row.detail}
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: 700, whiteSpace: 'nowrap', verticalAlign: 'top' }}>
                  {row.investment}
                </TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ bgcolor: theme.palette.secondary.light }}>
              <TableCell colSpan={2} sx={{ fontWeight: 800 }}>
                TOTAL MENSUAL — Plan de Dominio Multi-Pantalla
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 800, fontSize: '1.1rem' }}>
                $300
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 1.5, textAlign: 'center' }}>
        Montos orientativos en USD al mes.
      </Typography>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default InvestmentSummary;
